import { MedalStarIcon } from '@/components/dashboard/icons'

export function TierCardHeader({ glowColor, iconUrl, title }: { glowColor: string; iconUrl?: string; title: string }) {
	return (
		<div className='relative h-[360px] overflow-hidden bg-background'>
			<span
				className='pointer-events-none absolute inset-0'
				style={{
					background: `radial-gradient(ellipse 90% 70% at 50% 38%, ${glowColor}40 0%, ${glowColor}18 32%, transparent 68%)`,
				}}
			/>
			<span
				className='pointer-events-none absolute inset-0 opacity-30'
				style={{
					background: `conic-gradient(from 180deg at 50% 42%, transparent 0deg, ${glowColor} 14deg, transparent 28deg, transparent 72deg, ${glowColor} 86deg, transparent 100deg, transparent 144deg, ${glowColor} 158deg, transparent 172deg, transparent 216deg, ${glowColor} 230deg, transparent 244deg, transparent 288deg, ${glowColor} 302deg, transparent 316deg)`,
				}}
			/>
			<span
				className='pointer-events-none absolute left-1/2 top-[42%] h-[400px] w-[400px] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-55 blur-[100px]'
				style={{ backgroundColor: glowColor }}
			/>

			<div className='relative flex h-full items-center justify-center'>
				{iconUrl ? (
					<img src={iconUrl} alt={title} className='h-[360px] w-[360px] max-w-none object-contain drop-shadow-[0_16px_40px_hsl(var(--background)/0.55)]' />
				) : (
					<MedalStarIcon className='h-44 w-44' style={{ color: glowColor }} />
				)}
			</div>
		</div>
	)
}
